/**
 * In-memory state bridge for the payment page.
 *
 * Vue Router 4 no longer carries non-URL params (objects, functions, etc.)
 * across route navigations. This module stores the payload that
 * cf-payment-methods sets before navigating to the payment page, and
 * the payment page reads it on mount.
 */

let _state = null;

export function setPaymentPageState(state) {
  _state = state;
}

export function getPaymentPageState() {
  return _state;
}

export function clearPaymentPageState() {
  _state = null;
}
